import type { MissionWording } from '../../app/utils/mission-kind-profile.util';

import type { AccessGate } from './types/access-gate.type';
import { InfoAlert } from '../InfoAlert';

import { quotationLockMessage } from './utils/quotation-lock-message.util';

interface Props {
  // The mission access `updateQuotationRelatedFields`.
  readonly gate: AccessGate;
  // What the submitted quotation freezes on the page: « son adresse ne peut plus changer ».
  readonly lockedFields: string;
  readonly wording: MissionWording;
}

export const QuotationLockNotice = ({
  gate,
  lockedFields,
  wording,
}: Readonly<Props>) => {
  const message = quotationLockMessage(gate, lockedFields, wording);

  return message ? <InfoAlert sx={{ mb: 2 }}>{message}</InfoAlert> : null;
};
